import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = { updatePath: String };

  async selectImage(event) {
    event.preventDefault();

    const radio = this.element.querySelector('.billable-image-radio:checked');
    if (radio === null) {
      return;
    }

    const button = event.currentTarget;
    button.disabled = true;

    const { imageableId, imageableType } = radio.dataset;
    if (!(await this.#updateImage(imageableId, imageableType))) {
      button.disabled = false;
      return;
    }

    this.dispatch('request-close', { prefix: 'turbo-modal', target: this.element });
  }

  #updateImage(imageableId, imageableType) {
    const body = new FormData();
    body.append('imageable_id', imageableId);
    body.append('imageable_type', imageableType);

    const request = new FetchRequest('post', this.updatePathValue, {
      body,
      responseKind: 'turbo-stream',
    });

    return request
      .perform()
      .then((response) => {
        if (!response.ok) {
          console.error(`Failed to update the spec sheet image: ${response.statusCode}`);
        }

        return response.ok;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }
}
